/**
 * Fime – Case Studies Carousel (Embla, arrow-controlled)
 *
 * Shared between the Offering and Industries page templates — one
 * module, since the markup/behavior is identical in both. No
 * autoplay, no dots — just prev/next arrows, disabled at each end
 * (not looping).
 */

import EmblaCarousel from 'embla-carousel';

const caseStudiesEmblaNode = document.getElementById('case-studies-embla');

if (caseStudiesEmblaNode) {
	const viewportNode = caseStudiesEmblaNode.querySelector('.embla__viewport');
	const prevBtn = document.getElementById('case-studies-prev');
	const nextBtn = document.getElementById('case-studies-next');

	const caseStudiesEmblaApi = EmblaCarousel(viewportNode, {
		loop: false,
		align: 'start',
		containScroll: 'trimSnaps',
	});

	function updateCaseStudiesArrows() {
		if (prevBtn) prevBtn.disabled = !caseStudiesEmblaApi.canScrollPrev();
		if (nextBtn) nextBtn.disabled = !caseStudiesEmblaApi.canScrollNext();
	}

	caseStudiesEmblaApi.on('select', updateCaseStudiesArrows);
	caseStudiesEmblaApi.on('init', updateCaseStudiesArrows);
	updateCaseStudiesArrows();

	if (prevBtn) {
		prevBtn.addEventListener('click', function () {
			caseStudiesEmblaApi.scrollPrev();
		});
	}

	if (nextBtn) {
		nextBtn.addEventListener('click', function () {
			caseStudiesEmblaApi.scrollNext();
		});
	}
}
